import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { Grid, Typography, FormControl, Autocomplete } from "@mui/material";
import PropTypes from "prop-types";
import { OwnerFormFields } from "../OwnerForm";
import { ImageUploadArea } from "../../../../components";
import { FormLabelStyled, TextFieldStyled } from "./CreateOwnerForm.styles";
const CreateOwnerForm = (props) => {
  const { onLogoChange } = props;
  const intl = useIntl();
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const instancesSelectItems = React.useMemo(() => {
    return [
      {
        value: "insurance-brydge",
        element: "InsuranceBrydge"
      },
      {
        value: "soderberg",
        element: "Soderberg"
      }
    ];
  }, []);
  const handleChange = (field) => (event) => {
    setFieldValue(field, event.target.value);
  };
  const handleLogoChange = React.useCallback(
    (file) => {
      setFieldValue("logo", file || "");
      onLogoChange?.(file);
    },
    [setFieldValue, onLogoChange]
  );
  return /* @__PURE__ */ React.createElement(Grid, { sx: { width: "100%" }, container: true, spacing: 2 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.ownerData" }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.name" }), ` *`), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.ownerName && !!errors.ownerName,
      fullWidth: true,
      helperText: touched.ownerName && errors.ownerName ? errors.ownerName : null,
      name: "ownerName",
      placeholder: intl.formatMessage({ id: "owners.name" }).toUpperCase(),
      value: values.ownerName,
      variant: "outlined",
      onChange: handleChange("ownerName")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.address" }), ` *`), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.address && !!errors.address,
      fullWidth: true,
      helperText: touched.address && errors.address ? errors.address : null,
      name: "address",
      placeholder: intl.formatMessage({ id: "owners.address" }).toUpperCase(),
      value: values.address,
      variant: "outlined",
      onChange: handleChange("address")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.zipCode" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "zipCode",
      placeholder: intl.formatMessage({ id: "owners.zipCode" }).toUpperCase(),
      value: values.zipCode,
      variant: "outlined",
      onChange: handleChange("zipCode")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.city" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "city",
      placeholder: intl.formatMessage({ id: "owners.city" }).toUpperCase(),
      value: values.city,
      variant: "outlined",
      onChange: handleChange("city")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.ownerEmail" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.ownerEmail && !!errors.ownerEmail,
      fullWidth: true,
      helperText: touched.ownerEmail && errors.ownerEmail ? errors.ownerEmail : null,
      name: "ownerEmail",
      placeholder: intl.formatMessage({ id: "owners.email" }).toUpperCase(),
      type: "email",
      value: values.ownerEmail,
      variant: "outlined",
      onChange: handleChange("ownerEmail")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.ownerPhone" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "ownerPhone",
      placeholder: intl.formatMessage({ id: "owners.ownerPhone" }).toUpperCase(),
      value: values.ownerPhone,
      variant: "outlined",
      onChange: handleChange("ownerPhone")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.contactInformation" }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.contactName" }), ` *`), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.contactName && !!errors.contactName,
      helperText: touched.contactName && errors.contactName ? errors.contactName : null,
      fullWidth: true,
      name: "contactName",
      placeholder: intl.formatMessage({ id: "owners.contactName" }).toUpperCase(),
      value: values.contactName,
      variant: "outlined",
      onChange: handleChange("contactName")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.contactEmail" }), ` *`), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.contactEmail && !!errors.contactEmail,
      helperText: touched.contactEmail && errors.contactEmail ? errors.contactEmail : null,
      fullWidth: true,
      name: "contactEmail",
      placeholder: intl.formatMessage({ id: "owners.contactEmail" }).toUpperCase(),
      type: "email",
      value: values.contactEmail,
      variant: "outlined",
      onChange: handleChange("contactEmail")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 6 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.contactPhone" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      fullWidth: true,
      name: "contactPhone",
      placeholder: intl.formatMessage({ id: "owners.contactPhone" }).toUpperCase(),
      value: values.contactPhone,
      variant: "outlined",
      onChange: handleChange("contactPhone")
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.ownerSettings" }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(ImageUploadArea, { label: OwnerFormFields.Logo.Label, onChange: handleLogoChange })), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "global.pensioenbijIntegratie" })), /* @__PURE__ */ React.createElement(FormControl, { fullWidth: true }, /* @__PURE__ */ React.createElement(
    Autocomplete,
    {
      id: "instance",
      options: instancesSelectItems,
      getOptionLabel: (option) => option.element,
      value: instancesSelectItems.find((item) => item.value === values.instance) || null,
      onChange: (event, newValue) => {
        setFieldValue("instance", newValue?.value || "");
      },
      renderInput: (params) => /* @__PURE__ */ React.createElement(
        TextFieldStyled,
        {
          ...params,
          color: "secondary",
          name: "instance",
          placeholder: intl.formatMessage({ id: "global.pensioenbijIntegratie" }).toUpperCase(),
          variant: "outlined"
        }
      )
    }
  ))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(FormLabelStyled, null, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "global_kvkNumber" })), /* @__PURE__ */ React.createElement(
    TextFieldStyled,
    {
      color: "secondary",
      error: touched.kvkNumber && !!errors.kvkNumber,
      fullWidth: true,
      helperText: touched.kvkNumber && errors.kvkNumber ? errors.kvkNumber : null,
      name: "kvkNumber",
      placeholder: intl.formatMessage({ id: "global_kvkNumber" }).toUpperCase(),
      value: values.kvkNumber,
      variant: "outlined",
      onChange: handleChange("kvkNumber")
    }
  )));
};
CreateOwnerForm.propTypes = {
  onLogoChange: PropTypes.func
};
export default CreateOwnerForm;
